module.exports = __webpack_public_path__ + "img/cross-sector-col.jpg";